import React from "react";
import Button from "../../common/Button";
import { useDispatch } from "react-redux";
import { toggleModal } from "../../../reducers/modalReducer";

const Road = ({ title, upgradeToPro, keyTitle = "Free", company, setShowExpension }) => {
    const dispatch = useDispatch();
    return (
        <>
            <div className={`w100 df aic pr`}>
                {keyTitle && <div className="df fdc aic jcc w10" style={{ height: '153px' }}>
                    <div className={`bg76 c1 br20px fs1-75rem ttu df aic jcc w100 fw600`} style={{ padding: '0px 16px' }}>
                        {keyTitle}
                    </div>
                </div>
                }

                <div
                    className={`pr road ${keyTitle ? 'dib' : ''}`}
                    style={{ width: keyTitle ? keyTitle === "Lite" ? '60%' : keyTitle === "Pro" ? '65%' : keyTitle === "Free" ? '75%' : '87%' : '100%' }}
                >
                    {title && <span className='c1 br20px fs1rem bg76 pa zi1 df aic jcc' style={{ left: '2px', top: '2px', paddingLeft: '1rem', paddingRight: '1rem', height: '32px' }}>{title}</span>}
                    <span className='db' style={{ width: '100%', borderTop: '3px solid transparent', borderImage: 'repeating-linear-gradient( to right, white 0, white 10px,  transparent 10px, transparent 20px ) 1' }}></span>

                    {keyTitle === "Free" && (
                        <div
                            className="c1 fs1rem fw400 br50px px1rem py0-5rem tac pa"
                            style={{
                                backgroundColor: '#68D261',
                                width: '200px',
                                right: '-2px',
                                top: '-2px',
                            }}
                        >
                            Upgrade for more
                        </div>
                    )}
                </div>
                {((keyTitle === "Pro" && company?.['subscription'] === 'Lite') || (keyTitle !== "Free" && (!company?.['subscription'] || company?.['subscription'] === "Free"))) && (
                    <div className='df fdc jcfs aifs ml3rem bg1 br20px pa shadow' style={{ right: '0px', top: '0px', padding: '12px', zIndex: '999' }}>
                        <div className='mt1rem'>
                            <h3 className='c15 fs1rem fw400'>
                                <span className='c3 fs20px fw600'>{keyTitle === "Lite" ? "£8.25" : "£83.25"}</span>/month
                            </h3>
                            <p className='c15 fs13px op60'>billed annually</p>
                        </div>
                        <Button
                            btnType="warning"
                            customClassName="cp my0-5rem"
                            text="Buy Now"
                            style={{
                                maxWidth: '180px',
                            }}
                            onClick={() => {
                                setShowExpension(keyTitle);
                                dispatch(toggleModal({ open: 'subscriptionPaymentConfirm' }));
                            }}
                        />
                    </div>
                )}

            </div>
        </>
    )
}

export default Road